module.exports = __webpack_public_path__ + "img/1.f81e4c63.jpg";